import React, { useState, useEffect, useContext, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { AbilityContext, Can } from 'tools/ability';
import Rest from 'tools/rest';
import {
  Button,
  message,
  Typography,
  Form,
  Input,
  Select,
  Modal,
  DatePicker,
  InputNumber,
  Steps,
  Checkbox,
  Divider,
  Collapse,
  ConfigProvider,
  FloatButton,
  Space,
} from 'antd';
import {
  PlusOutlined,
  CopyOutlined,
  CheckOutlined,
  CloseOutlined,
  RollbackOutlined,
  SaveOutlined,
  ClearOutlined,
  FieldTimeOutlined,
  NodeExpandOutlined,
} from '@ant-design/icons';
import {
  CalendarPicker,
  Checkbox as MCheckbox,
  DatePicker as MDatePicker,
} from 'antd-mobile'
import {
  find as _find,
  forEach as _forEach,
  map as _map,
  includes as _includes,
  findIndex as _findIndex,
  reject as _reject,
  isEqual as _isEqual,
  range as _range,
  difference as _difference,
} from 'lodash';
import { toast, useToastContainer } from 'react-toastify';
import { parseISO as _parseISO, format } from 'date-fns';
import { faLeaf } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import { LeftOutline } from 'antd-mobile-icons';

import MobileFilesUploader from 'components/mobile_files_uploader';
import History from './components/history';

const { Text } = Typography;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

const MobileRequestCard = (props) => {
  const { match, classes } = props;
  const routerHistory = useHistory();
  const location = useLocation();
  const agreementPrefillDone = useRef(false);

  const exitRequestScreen = () => {
    const ret = location.state?.returnToAgreement;
    if (ret?.agreementsId != null && typeof ret.activeTab === 'number') {
      routerHistory.push({
        pathname: `/m/agreements/${ret.agreementsId}`,
        state: { activeTab: ret.activeTab },
      });
      return;
    }
    routerHistory.goBack();
  };

  const [messageApi, contextHolder] = message.useMessage();

  const toastify = (type, content) => {
    messageApi.open({
      type: type,
      content: content,
    });
  };

  const [request, setRequest] = useState({
    id: null,
    description: null,
    plan_started_at: null,
    plan_finished_at: null,
    request_type_id: null,
    request_subtype_id: null,
    request_status_id: null,
    request_reason_id: null,
    request_first_reason_id: null,
    responsible_user_id: null,
    executor_user_id: props.executor_user_id || null,
    car_id: props.car_id || null,
    project_id: null,
    resource_id: null,
    resource_type: null,
    resource: {
      identifier: null,
      address: null,
      name: null,
      phone: null,
      uid: null,
    },
    created_at: null,
    events: [],
    can_submit: null,
    project_managers: [],
  });
  const [currentRequest, setCurrentRequest] = useState({});
  const [requestTypes, setRequestTypes] = useState([]);
  const [requestSubtypes, setRequestSubtypes] = useState([]);
  const [requestStatuses, setRequestStatuses] = useState([]);
  const [requestFirstReasons, setRequestFirstReasons] = useState([]);
  const [requestReasons, setRequestReasons] = useState([]);
  const [requestId, setRequestId] = useState(match.params.request_id || null);
  const [blockingServiceId, setBlockingServiceId] = useState(null);
  const [comment, setComment] = useState(null);
  const [loading, setLoading] = useState(false);
  const [visibleSearchAgreement, setVisibleSearchAgreement] = useState(false);
  const [visibleSearchDevice, setVisibleSearchDevice] = useState(false);
  const [visibleSearchProject, setVisibleSearchProject] = useState(false);
  const [visibleSearchTimeslot, setVisibleSearchTimeslot] = useState(false);
  const [visibleAgreementCard, setVisibleAgreementCard] = useState(false);
  const [visiblePlanDate, setVisiblePlanDate] = useState(false);
  const [visiblePlanStarted, setVisiblePlanStarted] = useState(false);
  const [visiblePlanFinished, setVisiblePlanFinished] = useState(false);
  const [visibleHistory, setVisibleHistory] = useState(false);
  const [visibleTransfer, setVisibleTransfer] = useState(false);
  const [transferExecutorId, setTransferExecutorId] = useState(null);
  const [transferComment, setTransferComment] = useState('');
  const [users, setUsers] = useState([]);
  const [cars, setCars] = useState([]);
  const [errors, setErrors] = useState({});
  const [projects, setProjects] = useState([])
  const [resources, setResources] = useState([])

  const context = useContext(AbilityContext)
  const current_user = useSelector(state => state.user)

  const getRequest = () => {
    if (!requestId) { return }
    setLoading(true)
    Rest.get(`/api/v1/requests/${requestId}`).then(
      (response) => {
        const { request } = response.data;
        setRequest(request);
        setCurrentRequest(request);
        if (request.resource_id) {
          setResources([{ label: `${request.resource_type == 'LbAgreement' ? "📃" : "🖥️"} - ${request.resource.identifier}`, value: request.resource_id, resource_type: request.resource_type }])
        };
        if (request.project_id) {
          setProjects([{ label: request.project.name, value: request.project.id }])
        };
      }).catch((e) => {
        console.error('error', e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const createRequest = (actionAfterSave = 'noting') => {
    setErrors({})
    const params = {
      request: request,
      comment: comment,
    }
    setLoading(true);
    Rest.post(`/api/v1/requests.json`, params).then(
      (response) => {
        const { request } = response.data;
        setRequest(request);
        setCurrentRequest(request);
        setRequestId(request.id)
        setComment(null);
        toastify('success', 'Задача создана')
        if (actionAfterSave == 'close') {
          exitRequestScreen();
        }
      }).catch((e) => {
        setErrors(e.response.data.request.errors)
        toastify('error', 'Ошибка создания')
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateRequest = (actionAfterSave='noting') => {
    setErrors({})
    const params = {
      request: request,
      comment: comment
    }
    setLoading(true);
    Rest.put(`/api/v1/requests/${requestId}`, params).then(
      (response) => {
        const { request } = response.data;
        setRequest(request);
        setCurrentRequest(request);
        setComment(null);
        toastify('success', 'Изменения сохранены')
        if (actionAfterSave == 'close'){
          exitRequestScreen();
        }
      }).catch((e) => {
        setErrors(e.response.data.request.errors)
        toastify('error', 'Ошибка сохранения')
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getUsers = () => {
    setLoading(true);
    Rest.get(`/api/v1/users/help_desk_users.json`).then(
      (response) => {
        const { users } = response.data
        let new_users = [];
        let new_cars = [];
        _forEach(users, (user) => {
          user.department == 'car_park' ?
            new_cars.push({ label: user.name, value: user.id }) :
            new_users.push({ label: user.name, value: user.id })
        })
        setUsers(new_users);
        setCars(new_cars);
      }).catch((e) => {
        console.error('error', e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getRequestTypes = () => {
    setLoading(true);
    Rest.get(`/api/v1/request_types.json`).then(
      (response) => {
        const { request_types } = response.data
        setRequestTypes(_map(request_types, (type) => {
          return { label: type.name, value: type.id }
        }));
      }).catch((e) => {
        console.error('error', e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getSubtypes = () => {
    const params = {
      request_type_id: request.request_type_id,
    }
    setLoading(true);
    Rest.get(`/api/v1/request_subtypes.json`, { params: params }).then(
      (response) => {
        const { request_subtypes } = response.data
        setRequestSubtypes(_map(request_subtypes, (subtype) => {
          return { label: subtype.name, value: subtype.id }
        }));
        // setRequest({ ...request, request_subtype_id: null });
      }).catch((e) => {
        console.error('error', e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getReasons = () => {
    const params = {
      request_type_id: request.request_type_id,
    }
    setLoading(true);
    Rest.get(`/api/v1/request_reasons.json`, { params: params }).then(
      (response) => {
        const { request_reasons, request_first_reasons } = response.data
        setRequestReasons(_map(request_reasons, (reason) => {
          if (!reason.active) {
            return { label: reason.description, value: reason.id, disabled: true }
          }
          return { label: reason.description, value: reason.id }
        }));
        setRequestFirstReasons(_map(request_first_reasons, (first_reason) => {
          return { label: first_reason.name, value: first_reason.id }
        }));
      }).catch((e) => {
        console.error('error', e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getStatuses = () => {
    const params = {
      request_type_id: request.request_type_id,
    }
    setLoading(true);
    Rest.get(`/api/v1/request_statuses.json`, { params: params }).then(
      (response) => {
        const { request_statuses } = response.data
        const default_status = _find(request_statuses, { 'priority': 1 })
        setRequestStatuses(_map(request_statuses, (status) => {
          return { label: status.name, value: status.id }
        }));
        // setRequest({ ...request, request_status_id: default_status ? default_status.id : null });
      }).catch((e) => {
        console.error('error', e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getProjects = (context) => {
    const params = {
      context: context
    }
    Rest.get('/api/v1/projects/context_search.json', { params: params }).then((response) => {
      const { projects } = response.data;
      setProjects(_map(projects, (project) => {
        return { label: project.name, value: project.id }
      }))
    });
  };

  const getResources = (context) => {
    const params = {
      context: context
    }
    Rest.get('/api/v1/requests/resource_search.json', { params: params }).then((response) => {
      const { resources } = response.data;
      console.log(resources)
      setResources(_map(resources, (resource) => {
        return { label: `${resource.resource_type == 'LbAgreement' ? "📃" : "🖥️"} - ${resource.name}`, value: resource.id, resource_type: resource.resource_type }
      }))
    });
  };

  const save_and_close = (handleSaveReq) => {
    handleSaveReq('close');
  };
  const dataRelevanceChange = () => {
    setDataRelevance(new Date())
  };

  const handleChangeText = (e) => {
    const text = e.target.value?.trim() ? e.target.value : null
    setRequest({ ...request, [e.target.name]: text })
    setErrors({ ...errors, [e.target.name]: null })
  };

  const handleChangeComment = (e) => {
    const comment = e.target.value?.trim() ? e.target.value : null
    setComment(comment);
  };

  const openTransfer = () => {
    if (!_isEqual(request, currentRequest) || comment) {
      toastify('error', 'Необходимо сохранить изменения');
      return;
    }
    setTransferExecutorId(null);
    setTransferComment('');
    setVisibleTransfer(true);
  };

  const transferRequest = () => {
    const text = (transferComment || '').trim();
    if (!transferExecutorId) {
      toastify('error', 'Выберите исполнителя');
      return;
    }
    if (!text) {
      toastify('error', 'Комментарий обязателен');
      return;
    }
    if (transferExecutorId === request.executor_user_id) {
      toastify('error', 'Выберите другого исполнителя');
      return;
    }

    setLoading(true);
    Rest.post(`/api/v1/requests/${requestId}/transfer.json`, {
      executor_user_id: transferExecutorId,
      comment: text,
    }).then((response) => {
      const { request: updatedRequest, placeholder_id } = response.data;
      setRequest(updatedRequest);
      setCurrentRequest(updatedRequest);
      setComment(null);
      setVisibleTransfer(false);
      setTransferExecutorId(null);
      setTransferComment('');
      toastify('success', placeholder_id ? `Задача перенесена. Слот закрыт задачей №${placeholder_id}` : 'Задача перенесена');
    }).catch((e) => {
      const errors = e.response?.data?.request?.errors || {};
      const messages = Object.values(errors).flat().filter(Boolean);
      toastify('error', messages.length ? messages.join('. ') : 'Ошибка переноса задачи');
    }).finally(() => {
      setLoading(false);
    });
  };

  const handleChangeField = (value, field_name) => {
    let new_field = {
      ...request,
      [field_name]: value
    }
    if (field_name == 'request_type_id') {
      new_field['request_status_id'] = null
      new_field['request_subtype_id'] = null
      new_field['request_first_reason_id'] = null
    }
    setRequest(new_field)
    setErrors({
      ...errors,
      [field_name]: null
    })
  };

  useEffect(() => {
    getRequestTypes();
    getUsers();
    getRequest();
  }, []);

  useEffect(() => {
    const rid = match.params.request_id;
    if (rid) {
      agreementPrefillDone.current = false;
      return;
    }
    if (agreementPrefillDone.current) return;
    const ar = location.state?.agreementResource;
    if (!ar?.resource_id) return;
    agreementPrefillDone.current = true;
    setRequest((prev) => ({
      ...prev,
      resource_id: ar.resource_id,
      resource_type: ar.resource_type || 'LbAgreement',
      resource: {
        ...prev.resource,
        ...(ar.resource || {}),
      },
    }));
    setResources([
      {
        label: `${(ar.resource_type || 'LbAgreement') === 'LbAgreement' ? '📃' : '🖥️'} - ${ar.resource?.identifier || '—'}`,
        value: ar.resource_id,
        resource_type: ar.resource_type || 'LbAgreement',
      },
    ]);
  }, [match.params.request_id, location.state]);

  useEffect(() => {
    if (request.request_type_id) {
      getReasons();
      getSubtypes();
      getStatuses();
    };
  }, [request.request_type_id]);

  const size = 'large'

  const isCreate = !requestId;
  const isExecutorUser = current_user?.role === 'service_engineer';
  const closeDesc =
    (current_user?.role === 'manager' || current_user?.role === 'main_manager') &&
    _find(requestTypes, { value: request.request_type_id })?.label === 'Сервис';
  const typeEditable =
    isCreate || _find(requestTypes, { value: request.request_type_id })?.label === 'Служебная';

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            itemSelectedBg: '#8f00ff82',
            itemSelectedColor: '#FFFFFF',
            itemColor: '#FFFFFF',
          },
          Form: {
            labelHeight: '18px',
            lineHeight: '18px',
            labelFontSize: '12px',
            verticalLabelPadding: '0'
          },
          Input: {
            borderRadiusLG: '25px',
            paddingLG: '40px',
          },
          InputNumber: {
            borderRadiusLG: '25px',
            paddingLG: '40px',
          },
          Select: {
            borderRadiusLG: '25px',
            paddingLeft: '20px',
          },
          Collapse: {
            borderRadiusLG: '25px',
          },
          DatePicker: {
            borderRadiusLG: '25px',
          },
          Table: {
            cellPaddingBlock: '3px',
          },
        },
      }}
    >
      {contextHolder}
      <History
        visible={visibleHistory}
        closeHistory={()=>{setVisibleHistory(false)}}
        history={request.events}
      />
      <Modal
        title="Перенос задачи"
        open={visibleTransfer}
        onCancel={() => { setVisibleTransfer(false); }}
        onOk={transferRequest}
        okText="Перенести"
        cancelText="Отмена"
        okButtonProps={{
          disabled: !transferExecutorId || !(transferComment || '').trim(),
        }}
        confirmLoading={loading}
        width="92%"
        style={{ maxWidth: 480, top: 24 }}
      >
        <Text type="secondary">
          Задача перейдёт новому исполнителю без времени выполнения. Слот текущего исполнителя закроет новая задача с теми же данными.
        </Text>
        <Form layout="vertical" component="div" style={{ marginTop: 16 }}>
          <Form.Item label="Исполнитель" required>
            <Select
              size={size}
              showSearch
              placeholder="Исполнитель"
              optionFilterProp="children"
              filterOption={(input, option) => _includes(option.label.toLowerCase(), input.toLowerCase())}
              options={users.filter((user) => user.value !== request.executor_user_id)}
              value={transferExecutorId || undefined}
              onChange={(value) => { setTransferExecutorId(value); }}
            />
          </Form.Item>
          <Form.Item label="Комментарий" required>
            <TextArea
              rows={3}
              value={transferComment}
              placeholder="Комментарий обязателен"
              onChange={(e) => { setTransferComment(e.target.value); }}
            />
          </Form.Item>
        </Form>
      </Modal>
      <div className={classes.buttonBack} onClick={exitRequestScreen}>
        <LeftOutline />
      </div>
      <div className={classes.pageMain}>
        <div className={classes.pageContent}>
          <div className={classes.titleBar}>
            <Text strong className={classes.titleBarText}>
              {request.id ? `Задача № ${request.id}` : 'Новая задача'}
            </Text>
          </div>
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
        >
          <Form.Item
            label={<Text className={classes.menuItemLabel}>Тип</Text>}
            help={errors?.request_type_id && errors?.request_type_id.join(", ")}
            validateStatus={errors?.request_type_id && "error"}
          >
            {typeEditable ? (
              <Select
                size={size}
                allowClear
                value={request.request_type_id}
                options={requestTypes}
                optionFilterProp="children"
                filterOption={(input, option) => _includes(option.label.toLowerCase(), input.toLowerCase())}
                onChange={(value) => { handleChangeField(value, 'request_type_id'); }}
              />
            ) : (
              <Text style={{ paddingLeft: 16 }}>
                {_find(requestTypes, { value: request.request_type_id })?.label}
              </Text>
            )}
          </Form.Item>
          <Form.Item
            label={<Text className={classes.menuItemLabel}>Подтип</Text>}
            help={errors?.request_subtype_id && errors?.request_subtype_id.join(", ")}
            validateStatus={errors?.request_subtype_id && "error"}
          >
            {!isExecutorUser ? (
              <Select
                size={size}
                allowClear
                value={request.request_subtype_id}
                options={requestSubtypes}
                optionFilterProp="children"
                filterOption={(input, option) => _includes(option.label.toLowerCase(), input.toLowerCase())}
                onChange={(value) => { handleChangeField(value, 'request_subtype_id'); }}
              />
            ) : (
              <Text style={{ paddingLeft: 16 }}>
                {_find(requestSubtypes, { value: request.request_subtype_id })?.label}
              </Text>
            )}
          </Form.Item>
          <Form.Item
            label={<Text className={classes.menuItemLabel}>Статус</Text>}
            help={errors?.request_status_id && errors?.request_status_id.join(", ")}
            validateStatus={errors?.request_status_id && "error"}
          >
            <Select
              size={size}
              allowClear
              value={request.request_status_id}
              options={requestStatuses}
              optionFilterProp="children"
              filterOption={(input, option) => _includes(option.label.toLowerCase(), input.toLowerCase())}
              onChange={(value) => { handleChangeField(value, 'request_status_id'); }}
            />
          </Form.Item>
          <Form.Item
            label={<Text className={classes.menuItemLabel}>Причина обращения</Text>}
            help={errors?.request_first_reason_id && errors?.request_first_reason_id.join(", ")}
            validateStatus={errors?.request_first_reason_id && "error"}
          >
            <Select
              size={size}
              allowClear
              value={request.request_first_reason_id}
              options={requestFirstReasons}
              optionFilterProp="children"
              filterOption={(input, option) => _includes(option.label.toLowerCase(), input.toLowerCase())}
              onChange={(value) => { handleChangeField(value, 'request_first_reason_id'); }}
            />
          </Form.Item>
          <Form.Item
            label={<Text className={classes.menuItemLabel}>Описание</Text>}
            help={errors?.description && errors?.description.join(", ")}
            validateStatus={errors?.description && "error"}
          >
            <TextArea
              size={size}
              rows={4}
              name="description"
              onChange={handleChangeText}
              value={request.description}
              disabled={closeDesc || !request.request_type_id}
            />
          </Form.Item>
          {request.project_managers &&
            <Form.Item
              label={<Text className={classes.menuItemLabel}>МП:</Text>}
            >
              <div style={{display: 'flex', flexDirection: 'column', paddingLeft: '16px'}}>
                {_map(request.project_managers, (value) => (
                  <Text>{value}</Text>
                ))}
              </div>
            </Form.Item>
          }
          <Form.Item
            label={<Text className={classes.menuItemLabel}>Проект</Text>}
            help={errors?.project_id && errors?.project_id.join(", ")}
            validateStatus={errors?.project_id && "error"}
          >
            <Select
              size={size}
              allowClear
              value={request.project_id}
              options={projects}
              placeholder="Поиск..."
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => true}
              onChange={(value) => { handleChangeField(value, 'project_id'); }}
              onSearch={(value) => { getProjects(value) }}
            />
          </Form.Item>
          {!isExecutorUser && (
            <Form.Item
              label={<Text className={classes.menuItemLabel}>Автор</Text>}
              help={errors?.responsible_user_id && errors?.responsible_user_id.join(", ")}
              validateStatus={errors?.responsible_user_id && "error"}
            >
              {isCreate && (current_user?.role === 'manager' || current_user?.role === 'main_manager') ? (
                <Select
                  size={size}
                  allowClear
                  value={request.responsible_user_id}
                  options={users}
                  optionFilterProp="children"
                  filterOption={(input, option) => _includes(option.label.toLowerCase(), input.toLowerCase())}
                  onChange={(value) => { handleChangeField(value, 'responsible_user_id'); }}
                />
              ) : (
                <Text style={{ paddingLeft: 16 }}>
                  {_find(users, { value: request.responsible_user_id })?.label || '—'}
                </Text>
              )}
            </Form.Item>
          )}
          {!isExecutorUser && (
            <Form.Item
              label={<Text className={classes.menuItemLabel}>Исполнитель</Text>}
              help={errors?.executor_user_id && errors?.executor_user_id.join(", ")}
              validateStatus={errors?.executor_user_id && "error"}
            >
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <Select
                  size={size}
                  allowClear
                  style={{ flex: 1, minWidth: 0 }}
                  value={request.executor_user_id}
                  options={users}
                  optionFilterProp="children"
                  filterOption={(input, option) => _includes(option.label.toLowerCase(), input.toLowerCase())}
                  onChange={(value) => { handleChangeField(value, 'executor_user_id'); }}
                />
                {!request.parent_id && (
                  <Button
                    icon={<NodeExpandOutlined />}
                    size={size}
                    disabled={isCreate || !request.executor_user_id || !request.plan_started_at || !request.plan_finished_at}
                    onClick={openTransfer}
                  />
                )}
              </div>
            </Form.Item>
          )}
          {!isExecutorUser && (
            <Form.Item
              label={<Text className={classes.menuItemLabel}>Автомобиль</Text>}
              help={errors?.car_id && errors?.car_id.join(", ")}
              validateStatus={errors?.car_id && "error"}
            >
              <Select
                size={size}
                allowClear
                value={request.car_id}
                options={cars}
                optionFilterProp="children"
                filterOption={(input, option) => _includes(option.label.toLowerCase(), input.toLowerCase())}
                onChange={(value) => { handleChangeField(value, 'car_id'); }}
              />
            </Form.Item>
          )}
          <Form.Item
            label={<Text className={classes.menuItemLabel}>Начало</Text>}
            style={{ marginBottom: '0px' }}
          >
            {!isExecutorUser ? (
              <div
                style={{ display: 'flex' }}
                onClick={() => { setVisiblePlanStarted(true) }}
              >
                <Input
                  size={size}
                  name="plan_started_at"
                  value={
                    request.plan_started_at && dayjs(request.plan_started_at).isValid()
                      ? dayjs(request.plan_started_at).format('DD.MM.YYYY HH:mm')
                      : request.plan_started_at
                  }
                  readOnly
                  suffix={
                    <ClearOutlined onClick={(e) => {
                      e.stopPropagation()
                      setRequest({ ...request, plan_started_at: null })
                    }} />
                  }
                />
                <MDatePicker
                  visible={visiblePlanStarted}
                  onClose={() => {
                    setVisiblePlanStarted(false)
                  }}
                  precision='minute'
                  onConfirm={val => {
                    setRequest({ ...request, plan_started_at: format(val, 'dd.MM.yyyy HH:mm') })
                  }}
                />
              </div>
            ) : (
              <Text style={{ paddingLeft: 16 }}>
                {request.plan_started_at && dayjs(request.plan_started_at).isValid()
                  ? dayjs(request.plan_started_at).format('DD.MM.YYYY HH:mm')
                  : request.plan_started_at || '—'}
              </Text>
            )}
          </Form.Item>
          <Form.Item
            label={<Text className={classes.menuItemLabel}>Завершение</Text>}
            help={errors?.plan_do_daterange && errors?.plan_do_daterange.join(", ")}
            validateStatus={errors?.plan_do_daterange && "error"}
          >
            {!isExecutorUser ? (
              <div
                style={{ display: 'flex' }}
                onClick={() => { setVisiblePlanFinished(true) }}
              >
                <Input
                  size={size}
                  name="plan_finished_at"
                  value={
                    request.plan_finished_at && dayjs(request.plan_finished_at).isValid()
                      ? dayjs(request.plan_finished_at).format('DD.MM.YYYY HH:mm')
                      : request.plan_finished_at
                  }
                  readOnly
                  suffix={
                    <ClearOutlined onClick={(e) => {
                      e.stopPropagation()
                      setRequest({ ...request, plan_finished_at: null })
                    }} />
                  }
                />
                <MDatePicker
                  visible={visiblePlanFinished}
                  onClose={() => {
                    setVisiblePlanFinished(false)
                  }}
                  precision='minute'
                  onConfirm={val => {
                    setRequest({ ...request, plan_finished_at: format(val, 'dd.MM.yyyy HH:mm') })
                  }}
                />
              </div>
            ) : (
              <Text style={{ paddingLeft: 16 }}>
                {request.plan_finished_at && dayjs(request.plan_finished_at).isValid()
                  ? dayjs(request.plan_finished_at).format('DD.MM.YYYY HH:mm')
                  : request.plan_finished_at || '—'}
              </Text>
            )}
          </Form.Item>
          <Form.Item
            label={<Text className={classes.menuItemLabel}>Причина закрытия</Text>}
            help={errors?.request_reason_id && errors?.request_reason_id.join(", ")}
            validateStatus={errors?.request_reason_id && "error"}
          >
            <Select
              size={size}
              allowClear
              value={request.request_reason_id}
              options={requestReasons}
              optionFilterProp="children"
              filterOption={(input, option) => _includes(option.label.toLowerCase(), input.toLowerCase())}
              onChange={(value) => { handleChangeField(value, 'request_reason_id'); }}
            />
          </Form.Item>
          <Form.Item
            label={<Text className={classes.menuItemLabel}>Договор / Оборудование</Text>}
            help={errors?.resource_id && errors?.resource_id.join(", ")}
            validateStatus={errors?.resource_id && "error"}
          >
            <React.Fragment>
              {!isExecutorUser && (isCreate || !request.resource_id) ? (
                <Select
                  size={size}
                  allowClear
                  value={request.resource_id}
                  options={resources}
                  placeholder="№ договора / назв. оборуд."
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => true}
                  onChange={(value, option) => {
                    setRequest({
                      ...request,
                      resource_id: option['value'],
                      resource_type: option['resource_type']
                    })
                  }}
                  onSearch={(value) => { getResources(value); }}
                />
              ) : (
                request.resource?.identifier && (
                  <Text style={{ paddingLeft: 16 }}>{request.resource.identifier}</Text>
                )
              )}
              {request.resource?.identifier &&
                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '16px' }}>
                  <Text>{request.resource?.address}</Text>
                  {request.resource_type == "LbAgreement" &&
                    <Text>{request.resource?.name}</Text>
                  }
                  {request.resource_type == "LbAgreement" &&
                    <Text>{request.resource?.phone}</Text>
                  }
                </div>
              }
            </React.Fragment>
          </Form.Item>
          {request.created_at &&
            <Form.Item
              style={{ marginBottom: '0px' }}
              label={<Text className={classes.menuItemLabel}>Дополнительная информация</Text>}
            >
              <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '16px' }}>
                <Text>Создана: {format(_parseISO(request.created_at), 'dd.MM.yyyy HH:mm')}</Text>
              </div>
            </Form.Item>
          }
          <Form.Item>
            <TextArea
              placeholder='Оставьте комментарий'
              size={size}
              rows={4}
              onChange={handleChangeComment}
              value={comment}
            />
          </Form.Item>
        </Form>
        <MobileFilesUploader
          related_obj_type='Request'
          related_obj_id={requestId}
        />
        </div>
      </div>
      <div className={classes.actions}>
        <Button
          onClick={request?.id ? updateRequest : createRequest}
          style={{margin: '0', padding: '0', border:'none', height: 'inherit', background: 'none'}}
          disabled={_isEqual(request, currentRequest) && !comment}
        >
          <div className={classes.actionBlock}>
            <SaveOutlined className={classes.actionIcon} />
            <Text className={classes.actionLable}>Сохранить</Text>
          </div>
        </Button>
        <Button
          onClick={(e)=>{setVisibleHistory(!visibleHistory)}}
          style={{ margin: '0', padding: '0', border: 'none', height: 'inherit', background: 'none' }}
          // disabled={_isEqual(request, currentRequest) && !comment}
        >
          <div className={classes.actionBlock}>
            <FieldTimeOutlined className={classes.actionIcon} />
            <Text className={classes.actionLable}>История</Text>
          </div>
        </Button>
      </div>
    </ConfigProvider>
  );
};

const styles = (theme) => ({
  pageMain: {
    height: '100%',
    width: '100%',
    padding: '9px 10px',
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  pageContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    overflowY: 'scroll',
    overflowX: 'hidden',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    height: 'calc(100vh - 18vh)',
    paddingBottom: 'calc(8vh + 12px)',
    boxSizing: 'border-box',
    '&::-webkit-scrollbar': {
      display: 'none',
      width: 0,
      height: 0,
    },
  },
  titleBar: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 40,
    padding: '0 80px 4px',
    boxSizing: 'border-box',
  },
  titleBarText: {
    color: '#59059B',
    fontSize: 18,
    textAlign: 'center',
    lineHeight: 1.2,
  },
  actions: {
    height: '8vh',
    width: '100%',
    padding: '5px 10px',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    zIndex: 2,
  },
  actionBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  actionIcon: {
    fontSize: '30px'
  },
  actionLable: {
    fontSize: '8px'
  },
  repeatableBlock: {
    border: '1px solid black',
    padding: '15px',
    margin: '5px 0 10px 0',
    borderRadius: '25px',
    borderColor: '#FFFFFF',
  },
  menuItemLabel: {
    marginLeft: '15px',
    fontStyle: 'italic'
  },
  buttonBack: {
    width: '80px',
    height: '8vh',
    minHeight: '44px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    right: 0,
    left: 'auto',
    fontSize: '30px',
    color: '#59059B',
    zIndex: 20,
    cursor: 'pointer',
    boxSizing: 'border-box',
    backgroundColor: '#CDA5E6',
  },
});

const mapStateToProps = (state) => ({
    user: state.user,
});

export default connect(mapStateToProps, null)(withStyles(styles)(MobileRequestCard));
